<template>
  <section class="platform-banner">
    <h1 class="title">全球电子商务平台</h1>
    <div class="info">
      <p>
        全球电子商务将电子商务加速实现智能和需求的三大支柱整合到一个包罗万象的平台中，以推动您在全球的增长。
      </p>
    </div>
    <div class="nav" ref="navRef">
      <div class="nav-item" :class="{ action: actionNavItem === '1' }">
        <img src="@/assets/home/Hp-IconBox1-Global-Enablement.svg" alt="" />
        <a class="nav-item-text" href="#Enablement">全球赋能</a>
      </div>
      <div class="nav-item" :class="{ action: actionNavItem === '2' }">
        <img src="@/assets/home/Hp-IconBox2-global-Intelligence.svg" alt="" />
        <a class="nav-item-text" href="#Intelligence">全球情报</a>
      </div>
      <div class="nav-item" :class="{ action: actionNavItem === '3' }">
        <img src="@/assets/home/Hp-IconBox3-Global-demand.svg" alt="" />
        <a class="nav-item-text" href="#Demand">全球需求</a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PlatformBanner',
  data() {
    return {
      actionNavItem: ''
    }
  },
  methods: {
    handleScroll() {
      let scrollTop = document.documentElement.scrollTop
      if (scrollTop >= 560) {
        this.$refs['navRef'].className = 'nav fixed-nav'
        if (scrollTop < 2248) {
          this.actionNavItem = '1'
        } else if (scrollTop < 3818) {
          this.actionNavItem = '2'
        } else {
          this.actionNavItem = '3'
        }
      } else {
        this.actionNavItem = ''
        this.$refs['navRef'].className = 'nav'
      }
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  // 组件销毁前
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style scoped lang="less">
.platform-banner {
  width: 100%;
  height: 525px;
  background-image: url('../../../assets/platform/Platform-section-01-min.jpeg');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  padding-top: 130px;
  h1 {
    text-align: center;
    color: #2a2b2f;
    font-size: 48px;
  }
  .info {
    width: 500px;
    height: 175px;
    margin: 20px auto;
    text-align: center;
    font-size: 16px;
  }
  .nav {
    margin-top: -2px;
    padding: 15px 5%;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0px 25px 20px 0px rgba(0, 0, 0, 0.05);
    position: relative;
    z-index: 997;
    .nav-item {
      min-width: 300px;
      padding: 10px 35px;
      display: flex;
      flex-direction: column;
      align-items: center;
      border-bottom: 2px solid #2a2c2f1a;
      position: relative;
      &::after {
        content: '';
        position: absolute;
        left: 0;
        bottom: -3px;
        width: 100%;
        height: 5px;
        background-color: #2f5ad9;
        border-radius: 5px;
        opacity: 0;
        transform: all 0.5s;
      }
      .nav-item-text {
        margin-top: 20px;
        color: #2a2b2f;
        font-size: 18px;
        font-weight: 700;
        text-align: center;
      }
    }
    .action::after {
      opacity: 1;
    }
  }
  .fixed-nav {
    width: 100%;
    box-sizing: border-box;
    position: fixed;
    top: -100px;
    background-color: #fff;
  }
}
</style>
